// Import mutations
import { GET_COUNTRIES } from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_COUNTRIES] (state, countries) {
    state.all = countries
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/countries.js